
export namespace Session {
	let token: string | undefined = undefined;

	export function setToken(newToken: string, persist: boolean = false): void {
		if (persist) {
			localStorage.setItem("noxtum-session", newToken);
		} else {
			sessionStorage.setItem("noxtum-session", newToken);
		}
		token = newToken;
	}

	export function getToken(): string | undefined {
		if (token) {
			return token;
		}

		const storedToken = localStorage.getItem("noxtum-session") || sessionStorage.getItem("noxtum-session");
		token = storedToken || undefined;
		return token;
	}

	export function clearToken(): void {
		localStorage.removeItem("noxtum-session");
		sessionStorage.removeItem("noxtum-session");
		token = undefined;
	}

	export function isLoggedIn(): boolean {
		return getToken() !== undefined;
	}

}